import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "./Navbar";
import Footer from "./Footer";

const CGV = () => {
  return (
    <div className="page">
      <Helmet>
        <title>Conditions Générales de Vente – Deenzine</title>
        <meta name="description" content="Conditions générales de vente Deenzine : produits, prix, paiement, livraison." />
        <link rel="canonical" href={window.location.origin + "/cgv"} />
      </Helmet>

      <Navbar />

      <section className="section">
        <div className="container">
          <div className="card cardPad" style={{ maxWidth: 900, margin: "0 auto" }}>
            <h1 className="h2" style={{ color: "var(--brand)" }}>Conditions Générales de Vente (CGV)</h1>

            <h2 className="h2" style={{ fontSize: 18, marginTop: 18 }}>1. Produits</h2>
            <p className="p">
              Les produits vendus sont des sacs et accessoires faits main. De légères variations peuvent survenir.
            </p>

            <h2 className="h2" style={{ fontSize: 18, marginTop: 18 }}>2. Disponibilité</h2>
            <p className="p">Les produits sont proposés dans la limite des stocks disponibles.</p>

            <h2 className="h2" style={{ fontSize: 18, marginTop: 18 }}>3. Délais de traitement</h2>
            <p className="p">Préparation sous 1 à 7 jours ouvrés avant expédition.</p>

            <h2 className="h2" style={{ fontSize: 18, marginTop: 18 }}>4. Prix</h2>
            <p className="p">Prix en euros TTC. Modifiables sans effet rétroactif.</p>

            <h2 className="h2" style={{ fontSize: 18, marginTop: 18 }}>5. Paiement</h2>
            <p className="p">Paiement sécurisé via Stripe. Aucune donnée bancaire conservée par le site.</p>

            <h2 className="h2" style={{ fontSize: 18, marginTop: 18 }}>6. Retours & remboursements</h2>
            <p className="p">
              Aucun retour/remboursement sauf défaut constaté à réception (48h) avec photo.
            </p>

            <h2 className="h2" style={{ fontSize: 18, marginTop: 18 }}>7. Propriété intellectuelle</h2>
            <p className="p">Textes, images et logo sont protégés.</p>

            <h2 className="h2" style={{ fontSize: 18, marginTop: 18 }}>8. Loi applicable</h2>
            <p className="p">Loi française. Litiges soumis au tribunal compétent.</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CGV;
